import Count                 from "../../../../domain/fundamentals/count/Count";
import FetchStatusRepository from "../../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository      from "../../../../domain/fundamentals/message/notify/NotifyRepository";
import CurrentPage           from "../../../../domain/fundamentals/pagination/CurrentPage";
import Pagination            from "../../../../domain/fundamentals/pagination/Pagination";
import TotalPage             from "../../../../domain/fundamentals/pagination/TotalPage";
import CreatedAt             from "../../../../domain/fundamentals/trail/CreatedAt";
import Trail                 from "../../../../domain/fundamentals/trail/Trail";
import UpdatedAt             from "../../../../domain/fundamentals/trail/UpdatedAt";
import MailTemplate          from "../../../../domain/mail/template/MailTemplate";
import MailTemplateContent   from "../../../../domain/mail/template/MailTemplateContent";
import MailTemplateId         from "../../../../domain/mail/template/MailTemplateId";
import MailTemplateName       from "../../../../domain/mail/template/MailTemplateName";
import MailTemplateRepository from "../../../../domain/mail/template/MailTemplateRepository";
import MailTemplates          from "../../../../domain/mail/template/MailTemplates";
import MailTemplateSubject    from "../../../../domain/mail/template/MailTemplateSubject";
import FetchStatusDataSource  from "../../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import MailTemplateDataSource from "../../../../infrastructure/datasource/mail/template/MailTemplateDataSource";
import NotifyDataSource       from "../../../../infrastructure/datasource/notify/NotifyDataSource";

class GetMailTemplates {
  private readonly mailTemplateRepository: MailTemplateRepository = new MailTemplateDataSource(this.dispatch);
  private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(this.dispatch);
  private readonly notifyRepository: NotifyRepository = new NotifyDataSource(this.dispatch);

  constructor(private readonly dispatch) {
  }

  public async execute(currentPage: CurrentPage) {
    this.fetchStatusRepository.start();
    try {
      const response = await this.mailTemplateRepository.findByPage(currentPage);
      const list: MailTemplate[] = response.data.mailTemplates.map(mailTemplate => new MailTemplate(
        new MailTemplateId(mailTemplate.id),
        new MailTemplateName(mailTemplate.name),
        new MailTemplateSubject(mailTemplate.subject),
        new MailTemplateContent(mailTemplate.content),
        new Trail(
          new CreatedAt(mailTemplate.trail.createdAt),
          new UpdatedAt(mailTemplate.trail.updatedAt)
        )
      ));
      const pagination: Pagination = new Pagination(new CurrentPage(response.data.pagination.current), new TotalPage(response.data.pagination.total));
      const count: Count = new Count(response.data.count);
      this.mailTemplateRepository.setMailTemplates(new MailTemplates(list, pagination, count));
    } catch (e) {
      this.notifyRepository.fetchFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default GetMailTemplates;
